// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-contextmenu {
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.15);
    border-radius: .25rem;
    color: #373a3c;
    font-size: 16px;
    margin: 2px 0 0;
    min-width: 160px;
    outline: none;
    opacity: 0;
    padding: 5px 0;
    pointer-events: none;
    text-align: left;
    transition: opacity 250ms ease !important;
}

.react-contextmenu.react-contextmenu--visible {
    opacity: 1;
    pointer-events: auto;
    z-index: 9999;
}

.react-contextmenu-item {
    background: 0 0;
    border: 0;
    color: #373a3c;
	cursor: pointer;
    font-weight: 400;
    line-height: 1.5;
    padding: 4px 10px;
    text-align: inherit;
    white-space: nowrap;
}

.react-contextmenu-item.react-contextmenu-item--active,
.react-contextmenu-item.react-contextmenu-item--selected {
    background-color: azure;
    border-color: azure;
    text-decoration: none;
}

.react-contextmenu-item.react-contextmenu-item--disabled,
.react-contextmenu-item.react-contextmenu-item--disabled:hover {
    background-color: transparent;
    border-color: rgba(0,0,0,.15);
    color: #878a8c;
}

.react-contextmenu-item--divider {
    border-bottom: 1px solid rgba(0,0,0,.15);
    cursor: inherit;
    margin-bottom: 3px;
    padding: 2px 0;
}
.react-contextmenu-item--divider:hover {
    background-color: transparent;
    border-color: rgba(0,0,0,.15);
}

.react-contextmenu-item.react-contextmenu-submenu {
	padding: 0;
}

.react-contextmenu-item.react-contextmenu-submenu > .react-contextmenu-item {
}

.react-contextmenu-item.react-contextmenu-submenu > .react-contextmenu-item:after {
    content: "▶";
    display: inline-block;
    position: absolute;
    right: 7px;
}`, "",{"version":3,"sources":["webpack://./src/scss/react-contextmenu.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,4BAA4B;IAC5B,iCAAiC;IACjC,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,cAAc;CACjB,eAAe;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;;IAEI,6BAA6B;IAC7B,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;CACC,UAAU;AACX;;AAEA;AACA;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;AACd","sourcesContent":[".react-contextmenu {\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid rgba(0,0,0,.15);\n    border-radius: .25rem;\n    color: #373a3c;\n    font-size: 16px;\n    margin: 2px 0 0;\n    min-width: 160px;\n    outline: none;\n    opacity: 0;\n    padding: 5px 0;\n    pointer-events: none;\n    text-align: left;\n    transition: opacity 250ms ease !important;\n}\n\n.react-contextmenu.react-contextmenu--visible {\n    opacity: 1;\n    pointer-events: auto;\n    z-index: 9999;\n}\n\n.react-contextmenu-item {\n    background: 0 0;\n    border: 0;\n    color: #373a3c;\n\tcursor: pointer;\n    font-weight: 400;\n    line-height: 1.5;\n    padding: 4px 10px;\n    text-align: inherit;\n    white-space: nowrap;\n}\n\n.react-contextmenu-item.react-contextmenu-item--active,\n.react-contextmenu-item.react-contextmenu-item--selected {\n    background-color: azure;\n    border-color: azure;\n    text-decoration: none;\n}\n\n.react-contextmenu-item.react-contextmenu-item--disabled,\n.react-contextmenu-item.react-contextmenu-item--disabled:hover {\n    background-color: transparent;\n    border-color: rgba(0,0,0,.15);\n    color: #878a8c;\n}\n\n.react-contextmenu-item--divider {\n    border-bottom: 1px solid rgba(0,0,0,.15);\n    cursor: inherit;\n    margin-bottom: 3px;\n    padding: 2px 0;\n}\n.react-contextmenu-item--divider:hover {\n    background-color: transparent;\n    border-color: rgba(0,0,0,.15);\n}\n\n.react-contextmenu-item.react-contextmenu-submenu {\n\tpadding: 0;\n}\n\n.react-contextmenu-item.react-contextmenu-submenu > .react-contextmenu-item {\n}\n\n.react-contextmenu-item.react-contextmenu-submenu > .react-contextmenu-item:after {\n    content: \"▶\";\n    display: inline-block;\n    position: absolute;\n    right: 7px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
